function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { get, getRawValue } from '../../../utils/get';
export var getTickets = function getTickets(item) {
  if (item === void 0) {
    item = {};
  }

  var tickets = getRawValue(item, 'tickets');

  if (!tickets || !(tickets instanceof Array)) {
    return [];
  }

  var taxRate = get(item, 'event.registration.ticketing.config.taxConfig.rate');
  return tickets.map(function (_ref) {
    var name = _ref.name,
        free = _ref.free,
        price = _ref.price,
        _ref$dashboard = _ref.dashboard,
        dashboard = _ref$dashboard === void 0 ? {} : _ref$dashboard;
    return _objectSpread({
      name: name,
      isFree: free,
      price: price.amount,
      finalPrice: taxRate + price.amount
    }, dashboard.limited ? {
      unsold: dashboard.unsold || 0
    } : {});
  });
};